import { render, staticRenderFns } from "./dialog-confirmreloadpermission.vue?vue&type=template&id=4b604ed6&"
import script from "./dialog-confirmreloadpermission.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmreloadpermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports